<template>
    <div v-if="ready">


        <v-row class="pb-3">
            <v-col>
                <v-select label="Loja" :class="{ '-input-success': !customValidation.errors.store }"
                    :persistent-hint="showHint" hint="Escolha a loja onde este formato estará disponível" outlined dense
                    v-model="form.store" :items="stores" item-value="id" item-text="name"></v-select>
            </v-col>
            <v-col>
                <v-select :class="{ '-input-success': !customValidation.errors.mediatype_parents }" dense
                    :persistent-hint="showHint" hint="Escolha o tipo dessa mídia" :items="defaults.mediaTypes"
                    item-text="label" item-value="value" outlined v-model="form.mediaType.parents"
                    label="Tipo de mídia"></v-select>
            </v-col>
            <v-col>
                <v-text-field :class="{ '-input-success': !customValidation.errors.mediatype_category }" dense
                    :persistent-hint="showHint" hint="Digite a categoria de do formato dentro da sua loja"
                    v-model="form.mediaType.category" outlined label="Categoria de mídia"></v-text-field>
            </v-col>
        </v-row>

        <v-row class="pb-3">
            <v-col>

                <fieldset class="mb-2 pa-3">
                    <legend>Formato</legend>
                    <v-select :class="{ '-input-success': !customValidation.errors.format_print }" dense
                        label="Ordem dos termos do formato" :persistent-hint="showHint"
                        hint="Organize a exibição e montagem no nome do formato e mantenha-os organizados e agrupados na busca"
                        :items="defaults.format" item-text="label" item-value="value" outlined
                        v-model="form.format.print"></v-select>
                    <v-row>

                        <v-col>
                            <v-text-field :disabled="!form.format.print.includes('type')"
                                :class="{ '-input-success': !customValidation.errors.format_type }" dense
                                v-model="form.format.type" outlined label="Tipo" :persistent-hint="showHint"
                                :hint="form.format.print.includes('type') ? 'Ex.: Comercial, Painel' : null"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field :disabled="!form.format.print.includes('value')"
                                :class="{ '-input-success': !customValidation.errors.format_value }" dense
                                v-model="form.format.value" outlined label="Valor" :persistent-hint="showHint"
                                :hint="form.format.print.includes('value') ? 'Ex.: 15, 30, LED, Front light' : null"></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field :disabled="!form.format.print.includes('metric')"
                                :class="{ '-input-success': !customValidation.errors.format_metric }" dense
                                v-model="form.format.metric" outlined label="Métrica" :persistent-hint="showHint"
                                :hint="form.format.print.includes('metric') ? 'Ex.: Segundos, m²' : ''"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>Resultado: <strong>{{ format }}</strong></v-col>
                    </v-row>
                </fieldset>
            </v-col>
            <v-col>
                <fieldset class="mb-2 pa-3">
                    <legend>Agrupamento</legend>
                    <v-alert text type="info">Organize o inventário e ajude o usuário a encontrar o formato mais
                        rapidamente.<br>Exemplo: programas, cadernos, plataformas e outras
                        referências para este formato</v-alert>
                    <div v-for="(bucket, i) in form.buckets" :key="i">
                        <div class="d-flex">
                            <v-text-field dense v-model="bucket.title" label="Título" outlined></v-text-field>
                            <v-text-field dense v-model="bucket.name" class="mx-2" label="Valor"
                                outlined></v-text-field>
                            <v-btn icon text @click="removeItem()" color="error"><v-icon
                                    small>mdi-trash-can-outline</v-icon></v-btn>
                        </div>
                    </div>
                    <v-btn @click="addItem()" block color="primary" elevation="0">Adicionar agrupamento</v-btn>
                </fieldset>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-textarea :class="{ '-input-success': !customValidation.errors.description }" dense
                    :persistent-hint="showHint" hint="Faça uma breve descrição do formato para o cliente"
                    label="Descrição" v-model="form.description" outlined></v-textarea>

            </v-col>
            <v-col>
                <v-textarea dense :class="{ '-input-success': !customValidation.errors.advantage }"
                    :persistent-hint="showHint" hint="Faça uma defesa deste formato para o cliente" label="Vantagem"
                    v-model="form.advantage" outlined></v-textarea>

            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-textarea dense :class="{ '-input-success': !customValidation.errors.specifications }"
                    :persistent-hint="showHint" hint="Digite linha a linha as especificações técnicas para criação"
                    label="Especificações" v-model="form.specifications" outlined></v-textarea>
            </v-col>
            <v-col>
                <v-select dense class="-input-neutral" :persistent-hint="showHint"
                    hint="Digite a categoria de do formato dentro da sua loja" outlined label="Categoria do formato"
                    :items="defaults.categories" item-text="label" item-value="value"
                    v-model="form.category"></v-select>

                <v-text-field dense :class="{ '-input-success': !customValidation.errors.internalCode }"
                    :persistent-hint="showHint" hint="Código interno para identificação do formato"
                    v-model="form.internalCode" outlined label="Código do veículo"></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            
            <v-col>
                <v-row>
                    <v-col cols="12" md="4" sm="12"  v-for="(spec, i) in form.specificationTypes" :key="i">
                        <v-card class="relative pt-9">
                            <v-btn icon color="error" style="position: absolute; top: 3px; z-index: 1; right: 3px;" @click="removeOption(i)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                            <SpecificationsModule :snap="spec" @update-specs="updateSpecs(i, $event)"></SpecificationsModule>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4" sm="12">
                        <v-btn block class="py-12" @click="addOptionFile()" color="success" outlined>Adicionar opção de arquivo</v-btn>
                    </v-col>
                </v-row>
              
                
            </v-col>
        </v-row>

    </div>
</template>
<script>
import SpecificationsModule from './SpecificationsModule.vue'

export default {
    components: {
        SpecificationsModule
    },
    props: {
        snap: Object,
        stores: Array,
        showHint: Boolean
    },
    data: () => ({
        form: {},
        ready: false,
        specs: false,
        defaults: {
            format: [
                {
                    value: 'type value metric',
                    label: "Tipo Valor Métrica"
                },
                {
                    value: "type value",
                    label: "Tipo Valor"
                },
                {
                    value: "value type",
                    label: "Valor Tipo"
                },
                {
                    value: "metric value type",
                    label: "Métrica Valor Tipo"
                }
            ],
            mediaTypes: [

            ],
            categories: [

            ]

        },

    }),
    created() {
        const form = JSON.parse(JSON.stringify(this.snap))
        
         if(!form.hasOwnProperty('specificationTypes'))
                form.specificationTypes = []

        this.form = form
        this.specs = true
    },
    mounted() {
        this.ready = true
        const mediaTypes = this.$t('format.mediaTypes')
        for (let key in mediaTypes) {
            this.defaults.mediaTypes.push({ value: key, label: mediaTypes[key] })
        }

        const categories = this.$t('format.categories')
        for (let key in categories) {
            this.defaults.categories.push({ value: key, label: categories[key] })
        }
    },
    watch: {
        customValidation: {
            deep: true,
            handler(v) {
                console.log('changing-VALIDATION', this.customValidation)
                this.$emit('update-model', this.customValidation)
            }
        },
        form: {
            deep: true,
            handler(v) {
                this.$emit('update-form', v)
            }
        }
    },
    computed: {
        format() {
            const f = this.form.format
            return f.print.replace('value', f.value).replace('type', f.type).replace('metric', f.metric)
        },
        customValidation() {
            const { store, format, mediaType, description, specifications, internalCode, category, advantage } = this.form
            const result = {
                errors: {},
                ok: 0,
                percent: 0,
                total: 8
            }
            if (!this.ready) return result
            result.errors.store = !store ? 'Loja é obrigatório' : null
            result.errors.mediatype_parents = !mediaType.parents ? 'Tipo de mídia é obrigatório' : null
            result.errors.mediatype_category = !mediaType.category ? 'Categoria do tipo de mídia é obrigatório' : null
            result.errors.format_print = !format.print ? 'Ordem dos termos é obrigatório' : null
            if (format.print.includes('value')) {
                result.errors.format_value = !format.value ? 'Valor do formato é obrigatório' : null
                result.total++
            }
            // else
            //     result.errors.format_value = null
            if (format.print.includes('metric')) {
                result.errors.format_metric = !format.metric ? 'Métrica do formato é obrigatório' : null
                result.total++
            }
            // else
            //     result.errors.format_metric = null
            if (format.print.includes('type')) {
                result.errors.format_type = !format.type ? 'Tipo do formato é obrigatório' : null
                result.total++
            }
            // else
            //     result.errors.format_type = null

            result.errors.description = !description ? 'Descrição é obrigatório' : null
            result.errors.advantage = !advantage ? 'Vantagem é obrigatório' : null
            result.errors.specifications = !specifications ? 'Especificações é obrigatório' : null
            result.errors.internalCode = !internalCode ? 'Código interno é obrigatório' : null
            // result.errors.category = !category ? 'Categoria interno é obrigatório' : null

            const errorsFind = Object.values(result.errors).filter(err => err !== null)
            result.ok = result.total - errorsFind.length
            result.percent = result.ok * 100 / result.total
            return result
        }
    },
    methods: {
        updateSpecs(i, e){
            this.form.specificationTypes[i] = e
            this.$emit('update-form', this.form)
        },
        addOptionFile() {
            this.specs = true
           this.form.specificationTypes.push({type: '', limits: {}})
            console.log('this.form.specificationTypes', this.form.specificationTypes)
            // setTimeout(() => {
                this.specs = false
            // },2000)
        },
        removeOption(index) {
            this.form.specificationTypes.splice(index, 1)
        },
        addItem() {
            this.form.buckets.push({ title: "", name: "" })
        },
        removeItem(index) {
            this.form.buckets.splice(index, 1)
        }
    }
}
</script>